import StatefulComponent from '../../base/StatefulComponent';
import Notification from './Notification';
import NotificationsCounter from './NotificationsCounter';

export default class Notifications extends StatefulComponent {
    init() {
        // check every two minutes
        this.interval = 60 * 2000;

        this.state = {
            'isOpen': false,
            'count': 0,
            'notifications': []
        };

        this.checkForNotifications();
        this.setupTimer();

        this.counter = new NotificationsCounter(this.childElements('.notifications__count'));
        this.counter.init();
        this.counter.render();

        this.bindEvents();
    }

    bindEvents() {
        this.element.on('click', '.notifications__opener', (e) => {
            e.preventDefault();
            this.toggle();
        });

        this.element.on('click', 'button', (e) => {
            e.preventDefault();
            this.clearAll();
        })
    }

    checkForNotifications() {
        $.get(this.getCheckUrl(), (response) => {
            if (response.Notifications) {
                this.setState({
                   notifications: response.Notifications,
                   count: response.Notifications.length
                });
            }
        });
    }

    setupTimer() {
        setInterval(() => {
            this.checkForNotifications();
        }, this.interval)
    }

    getCheckUrl() {
        return this.element.data('check-url');
    }

    getMarkReadUrl() {
        return this.element.data('mark-read-url');
    }

    getCountUrl() {
        return this.element.data('count-url');
    }

    /**
     * Gets the dom element for the list of notifications.
     *
     * @returns {HTMLElement[]}
     */
    getNotificationsList() {
        return this.childElements('.notifications__list')
    }

    /**
     * Handles the click of a notification. Redirects to call to action if there is one.
     *
     * @param notification
     */
    handleNotificationClick(notification) {
        // redirect to call to action
        if (notification.CallToActionURL && notification.CallToActionURL !== null) {
            $.get(this.getMarkReadUrl() + '/' + notification.ID).then(_ => {
                window.location = notification.CallToActionURL;
            });
        }
    }

    /**
     * Handles the dismiss click of a notification.
     *
     * @param notification
     */
    handleNotificationDismissClick(notification) {
        $.get(this.getMarkReadUrl() + '/' + notification.ID, (response) => {

            const notifications = this.state.notifications.filter(n => n.ID != notification.ID);

            // update count
            this.setState({
                count: this.state.count - 1,
                notifications: notifications
            });
        });
    }

    /**
     * Closes the list
     */
    close() {
        this.setState({
            'isOpen': false
        });
    }

    /**
     * Opens the list
     */
    open() {
        this.setState({
            'isOpen': true
        });
    }

    /**
     * Toggles the list open/closed
     */
    toggle() {
        this.setState({
            'isOpen': !this.state.isOpen
        });
    }

    clearAll() {
        $.get(this.getMarkReadUrl() + '/all', (response) => {
            this.setState({
                count: 0,
                notifications: []
            });
        });
    }

    render() {
        let list = this.getNotificationsList(),
            listContainer = list.find('.notifications__list-container');

        // update count
        this.counter.setState({
            count: this.state.count
        });

        // update list
        listContainer.html('');

        this.state.notifications.map((notification) => {
            let o = new Notification();

            o.init();
            o.setOnClick((n) => this.handleNotificationClick(n))
                .setOnDismissClick((n) => this.handleNotificationDismissClick(n))
                .setState({
                    'listContainer': listContainer,
                    'notification': notification
                });
        });

        if (listContainer.children().length == 0) {
            listContainer.append($(`
<div class="notifications__notification">
    <h4 class="notifications__notification-title"><em>No pending notifications.</em></h4>
</div>`));
            this.element.find('button').hide();
        } else {
            this.element.find('button').show();
        }



        // hide list if no messages or not open
        if (!this.state.isOpen) {
            this.element.removeClass('open');
        } else if (this.state.isOpen) {
            this.element.addClass('open');
        }
    }
}
